import axios from 'axios';
import { trackEvent, AnalyticsConstants } from './analyticsUtilities';

export function storeAuthData(token, expiresIn) {
    const authorizationHeader = 'Bearer ' + token;
    axios.defaults.headers.common['Authorization'] = authorizationHeader;
    localStorage.setItem('Token', token);
    const expiryDate = new Date();
    expiryDate.setSeconds(expiryDate.getSeconds() + expiresIn);
    localStorage.setItem('ExpiryDate', expiryDate.toISOString());
}
export function logout() {
    trackEvent('Signed Out', {
        category: AnalyticsConstants.ACCOUNT_CATEGORY
    });

    localStorage.removeItem('Token');
    localStorage.removeItem('ExpiryDate');
    localStorage.removeItem('PlanDetails');
    window.location.reload();
}
export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const routesWithDisabledLoginForm = ["/password-reset"];

const conditionallyExecute = (callback) => {
    if (!routesWithDisabledLoginForm.includes(window.location.pathname)) {
        callback();
    }
};

export function isAuthorizationTokenExpired() {
    return !localStorage.getItem('Token') ||
           !localStorage.getItem('ExpiryDate') ||
           localStorage.getItem('ExpiryDate') && new Date(localStorage.getItem('ExpiryDate')) < new Date();
}

export function checkToken(storeInHeaders, onValid, onExpired, onNone) {
    if (localStorage.getItem('Token') != null && localStorage.getItem('ExpiryDate') != null && new Date(localStorage.getItem('ExpiryDate')) > new Date()) {
        const token = localStorage.getItem('Token');

        if (storeInHeaders) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
        if (typeof onValid === "function") {
            conditionallyExecute(() => onValid(token));
        }
    } else if (localStorage.getItem('Token') != null) {
        if (typeof onExpired === "function") {
            conditionallyExecute(onExpired);
        }
    } else {
        if (typeof onNone === "function") {
            conditionallyExecute(onNone);
        }
    }
}
